import { Label } from "@mui/icons-material";

import {
  FetchRolesResponse,
  FetchUsersResponse,
  ParsedFetchUserResponse,
  ParsedRoleResponse,
  Role,
  User,
  FetchProgramResponse,
  ParsedProgramResponse,
  program,
  ParseProgramTypeResponse,
  FetchProgramTypeResponse,
  programType,
  //   ParseProjectData,
  FetchProjectResponse,
  ProjectType,
  RoleData,
} from "../types/user";

const userParser: any = {};

userParser.fetchedUsers = (
  response: FetchUsersResponse
): ParsedFetchUserResponse => {
  let data: User[] = [];

  if (
    response.success &&
    typeof response.data === "object" &&
    response.data !== null &&
    Array.isArray(response.data.rows) &&
    response.data.rows.length > 0
  ) {
    data = response.data.rows;
  }
  let total = response?.data?.rowsCount;
  const userRows = data.map((user: User) => ({
    id: user.userId,
    username: user.username,
    department: user.department,
    email: user.email,
    roleId: user.roleId,
    roleName: user.roleName,
    phoneNo: user.phoneNo,
    location: user.location,
    empId: user.empId,
    createdBy: user.createdBy,
    createdAt: user.createdAt,
    updatedAt: user.updatedAt,
    publishedAt: user.publishedAt,
    isActive: user.isActive,
    program: user.programs,
    center: user.center,
  }));

  return {
    // @ts-ignore
    users: userRows,
    totalUsers: total,
  };
};

userParser.userRoles = (res: FetchRolesResponse): any => {
  let data: any = [];

  if (
    res.success &&
    res.data !== null &&
    res.data.rows.length > 0 &&
    typeof res.data === "object" &&
    Array.isArray(res.data.rows)
  ) {
    data = res.data;
  }

  const RolesData = data?.rows?.map((role: any) => ({
    label: role.roleName,
    value: role.roleId,
    isAdmin: role.isAdmin,
    isActive: role.isActive,
    userAccessControl: role.scopeParents,
    createdAt: role.createdAt,
    rowCount: 13,
  }));

  return {
    userRoles: RolesData,
    rowsCount: data?.rowsCount,
  };
};

userParser.userProgram = (
  res: FetchProgramResponse
): ParsedProgramResponse[] => {
  let data: program[] = [];
  if (
    res.success &&
    res.data !== null &&
    Array.isArray(res.data) &&
    res.data.length > 0
  ) {
    data = res.data;
  }
  return data.map((program) => {
    return {
      label: program.programMasterName,
      value: program.programMasterId,
    };
  });
};

userParser.userProgramType = (
  res: FetchProgramTypeResponse
): ParseProgramTypeResponse[] => {
  let data: programType[] = [];
  if (
    res.success &&
    res.data !== null &&
    Array.isArray(res.data) &&
    res.data.length > 0
  ) {
    data = res.data;
  }

  return data.map((program) => {
    return {
      label: program.programType,
      value: program.programTypeId,
      modules: [],
    };
  });
};

// userParser.userProjects = (res: FetchProjectResponse): any[] => {
//     let data: ProjectType[] = [];
//   if (
//     res.success &&
//     res.data !== null &&
//     Array.isArray(res.data) &&
//     res.data.length > 0
//   ) {
//     data = res.data;
//   }

//   console.log("first", data)

//   // Map the data into the desired format
//   return data.map((project) => {
//     const scopeData = project.scopes.map((scope:any) => ({
//       value: scope.scopeId,
//       label: scope.scopeName,
//     }));

//     console.log("Scope", scopeData);

//     return {
//       value: project.scopeParentId,
//       label: project.scopeParentName,
//       scopes: scopeData,
//     };
//   });
// };

userParser.userProjects = (res: FetchProjectResponse): any => {
  let data: ProjectType[] = [];

  // Validate response
  // Improved condition to ensure data is not only an array but also contains objects of a specific type
  if (
    res.success &&
    Array.isArray(res.data) &&
    res.data.length > 0 &&
    res.data.every((item) => typeof item === "object" && item !== null)
  ) {
    data = res.data;
  }

  const result = data?.map((project: any, index: number) => {
    const scopeData =
      project?.scopes?.map((scope: any) => ({
        value: scope.scopeId,
        label: scope.scopeName,
        isActive: scope.scopeIsActive,
        children:
          scope.children?.map((child: any, index: number) => ({
            value: child.childId,
            label: child.childName,
            isActive: child.scopeChildIsActive,
          })) || [],
      })) || [];

    return {
      id: index,
      value: project.scopeParentId,
      label: project.scopeParentName,
      scopes: scopeData,
    };
  });

  return result;
};

userParser.getRolesByIdParser = (res: any): any => {
  let data: any = [];

  if (
    res.success &&
    res.data !== null &&
    Array.isArray(res.data) &&
    res.data.length > 0
  ) {
    data = res.data;
  }

  const result = data?.map((item: any) => ({
    roleId: item?.roleId,
    roleName: item?.roleName,
    isActive: item?.isActive,
    programType: item?.programType?.map((item: any) => ({
      programType: item?.programType,
      programTypeId: item?.programTypeId,
    })),
    scopeParents: item?.scopeParents?.map((item: any) => ({
      scopeParentId: item?.scopeParentId,
      scopes: item?.scopes?.map((scope: any) => ({
        scopeId: scope.scopeId,
        scopeName: scope.scopeName,
        canRead: scope.canRead,
        canWrite: scope.canWrite,
        canUpdate: scope.canUpdate,
        canDelete: scope.canDelete,
        scopeChild: scope.scopeChild?.map((child: any) => ({
          childId: child.childId,
          childName: child.childName,
          canRead: child.canRead,
          canWrite: child.canWrite,
          canUpdate: child.canUpdate,
          canDelete: child.canDelete,
        })),
      })),
    })),
  }));

  return result;
};

export default userParser;
